module.exports = __webpack_public_path__ + "img/0Q3A3375_FoamcoreMatted.cea07f12.jpg";